import { gql } from "lib/apolloClient";
import { subjectFragment } from "modules/CommonFragments";

export const organizationSubjectsFragment = {
  organizationSubjects: gql`
    fragment organizationItem on Organization {
      id
      subjects(filters: $filters) {
        ...subjectItem
      }
    }
    ${subjectFragment.subjectBenchmarkDetails}
  `,
};
